module.exports = __webpack_public_path__ + "media/cortina/guia-conajustedeviga-af4fa3d3.png";